<div class="dialog-container">
  <div class="dialog-header">
    <div class="header-content">
      <mat-icon class="header-icon">content_paste_go</mat-icon>
      <h2 mat-dialog-title>{{ data?.titulo || 'Importar Múltiplas Postos' }}</h2>
    </div>
    <button mat-icon-button (click)="cancelar()" class="close-button" matTooltip="Fechar diálogo">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-content">
    <div class="instructions-container">
      <p class="dialog-instructions">
        {{ data?.descricao || 'Cole os códigos das frotas abaixo, um código por linha.' }}
      </p>
    </div>
    
    <div class="input-container">
      <mat-form-field appearance="outline" class="full-width" [class.input-invalido]="contemCaracteresInvalidos">
        <mat-label>{{ data?.titulo ? 'Códigos de ' + data.titulo.split(' ').pop() : 'Códigos das Frotas' }}</mat-label>
        <textarea 
          matInput 
          [(ngModel)]="textoFrotas" 
          (ngModelChange)="atualizarContadorCodigosValidos()"
          rows="10" 
          placeholder="Cole os códigos aqui, um por linha"
          #textoInput
          (paste)="onPaste($event)"
          (keydown)="onKeyDown($event)"
          autocomplete="off">
        </textarea>
        <mat-hint *ngIf="!contemCaracteresInvalidos" class="contador-hint">
          <span>Digite apenas números</span>
          <span *ngIf="textoFrotas" class="contador-validos">
            <mat-icon class="icon-contador">check_circle</mat-icon>
            {{ codigosValidosCount }} código(s) válido(s)
          </span>
        </mat-hint>
        <mat-hint *ngIf="contemCaracteresInvalidos" class="hint-erro">
          <mat-icon class="icon-erro">warning</mat-icon>
          Caracteres não numéricos foram detectados e serão removidos
        </mat-hint>
        <button 
          *ngIf="textoFrotas" 
          matSuffix 
          mat-icon-button 
          aria-label="Limpar" 
          (click)="limparTexto()"
          matTooltip="Limpar texto">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>

    <div class="action-buttons">
      <div class="buttons-container">
        <button mat-stroked-button (click)="cancelar()" class="btn-limpar">
          Cancelar
        </button>
        <button 
          mat-raised-button 
          color="primary" 
          [disabled]="codigosValidosCount === 0" 
          (click)="confirmar()"
          class="btn-consulta hover-effect primary-button"
          [style.opacity]="codigosValidosCount === 0 ? '0.6' : '1'"
          [style.background-color]="codigosValidosCount === 0 ? 'rgba(214, 11, 82, 0.3)' : ''">
          <mat-icon>save</mat-icon> Importar {{ codigosValidosCount > 0 ? '(' + codigosValidosCount + ')' : '' }}
        </button>
      </div>
    </div>
  </div>
</div> 